<template>
  <el-card>
    <el-form ref="form" class="global-form2" :model="info" :rules="rules" label-position="right" label-width="110px">
      <el-form-item prop="projectId" label="所属项目">
        <el-select v-model="info.projectId" filterable placeholder="请选择所属项目" @change="getTypeList">
          <el-option v-for="item in normalProjectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="orderType" label="工单类型">
        <el-select v-model="info.orderType" placeholder="请选择工单类型" filterable :disabled="!info.projectId"
          @change="getRoleList">
          <el-option v-for="item in typeList" :key="item.orderType" :label="item.orderTypeName"
            :value="item.orderType"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item prop="orderTitle" label="工单主题">
        <el-input v-model="info.orderTitle" placeholder="请输入工单主题"    maxlength="50" />
      </el-form-item> -->
      <el-form-item prop="orderContent" label="工单详情">
        <el-input type="textarea" maxlength="200" placeholder="请输入工单详情" :rows="3" show-word-limit
          v-model="info.orderContent"></el-input>
      </el-form-item>
      <el-form-item label="工单截止日期" prop="orderDate">
        <el-date-picker v-model="info.orderDate" type="date" value-format="yyyy-MM-dd" :picker-options="pickerOptions"
          placeholder="请选择工单截止日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="作业区域">
        <el-select v-model="info.projectAreaId" placeholder="请选择作业区域" filterable clearable>
          <el-option v-for="item in areaList" :key="item.projectAreaId" :label="item.areaName"
            :value="item.projectAreaId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="address" label="作业地点">
        <el-input v-model="info.address" readonly placeholder="请输入作业地点" maxlength="50" />
        <el-button class="address" type="primary" @click="getAddressInfo()" :disabled="!info.projectId">地图定位</el-button>
      </el-form-item>

      <el-form-item prop="projectPosition" label="详细位置描述">
        <el-input type="textarea" v-model="info.projectPosition" placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="现场图像" prop="fileList">
        <template slot="label">
          <span>
            现场图像
          </span>
        </template>
        <div class="imgList">
          <template v-if="info.fileList.length > 0">
            <div class="imgBlock" v-for="(item, index) in info.fileList" :key="index">
              <el-image v-if="imgList.find((items) => items === item.fileName.split('.')[1])"
                :src="item.filePrefix + item.fileUrl" :preview-src-list="info.fileList | imgListFormat" fit="fill">
              </el-image>
              <video v-if="videoList.find((items) => items === item.fileName.split('.')[1])" controls="controls"
                :src="item.filePrefix + item.fileUrl" :preview-src-list="[item.filePrefix + item.fileUrl]" fit="fill">
              </video>
              <i class="el-icon-close" @click="imgRemove(index)"></i>
            </div>
          </template>
          <UploadFile :accept="'mp4,mov,jpeg,jpg,png'" v-if="info.fileList.length < 6" @onSuccess="onSuccess"
            :slotShow='true'>
            <template>
              <i class="el-icon-plus"></i>
              <p>上传图像</p>
            </template>
          </UploadFile>
        </div>
        <div class="mt20">(图片/视频选填，最多六张)</div>
      </el-form-item>
      <el-form-item prop="orderUserId" label="工单处理人">
        <el-select v-model="info.orderUserId" placeholder="请选择工单处理人" filterable :disabled="!info.projectId">
          <el-option v-for="item in roleList" :key="item.userId" :label="item.userName"
            :value="item.userId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="saveForm" :disabled='submitShow'>保存</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>

    <el-dialog title="地图定位" :visible.sync="addressShow" :close-on-click-modal="false" class="dialog-form" width="800px"
      :before-close="handleClose">
      <div id="map"></div>
      <div class="search">
        <el-autocomplete size="small" v-model="addressInfo.address" style="width: 500px; height: 36px;"
          :fetch-suggestions="addrFetch" placeholder="请搜索并选择位置" @select="addrChange" prefix-icon="el-icon-search"
          :maxlength='50'>
          <template slot-scope="{ item }">
            <span>{{ item.name }}</span>
          </template>
        </el-autocomplete>
      </div>
      <el-button type="primary" @click="submitAddress" class="submitBtn">提交</el-button>
    </el-dialog>
  </el-card>
</template>

<script>
import UploadFile from '@/components/uploadFile/Index.vue'
import LocationImg from '@/assets/img/icon_address.png'

export default {
  name: 'MyOrderAdd',
  components: { UploadFile },
  data() {
    return {
      info: {
        projectId: '',
        orderType: '',
        orderTitle: '',
        orderContent: '',
        orderDate: '',
        address: '',
        fileList: [],
        orderUserId: '',
        longitude: '',
        latitude: '',
        projectPosition: '',
        projectAreaId: ''
      },

      typeList: [],
      roleList: [],

      dateArr: [],
      submitShow: false,
      imgList: ['jpeg', 'jpg', 'png'],
      videoList: ['mp4', 'mov'],
      addressShow: false,
      map: null,
      marker: [],
      areaList: [],
      addressInfo: {
        longitude: '',
        latitude: '',
        address: '',
        area: ''
      },

      rules: {
        projectId: [
          { required: true, message: '请选择所属项目', trigger: ['blur', 'change'] }
        ],
        orderType: [
          { required: true, message: '请选择工单类型', trigger: ['blur', 'change'] }
        ],
        orderTitle: [
          { required: true, message: '请输入工单主题', trigger: ['blur', 'change'] }
        ],
        orderContent: [
          { required: true, message: '请输入工单详情', trigger: ['blur', 'change'] }
        ],
        orderDate: [
          { required: true, message: '请选择工单截止日期', trigger: ['blur', 'change'] }
        ],
        orderUserId: [
          { required: true, message: '请选择工单处理人', trigger: ['blur', 'change'] }
        ],
        address: [
          { required: true, message: '请输入作业地点', trigger: ['blur', 'change'] }
        ]
      },

      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '本周',
            onClick(picker) {
              const date = new Date()
              const day = date.getDay() === 0 ? 0 : (7 - date.getDay())
              date.setTime(date.getTime() + 3600 * 1000 * 24 * day)
              picker.$emit('pick', date)
            }
          },
          {
            text: '本月',
            onClick(picker) {
              const date = new Date()
              if (date.getMonth() === 11) {
                date.setFullYear(date.getFullYear() + 1, 0, 1)
                date.setTime(date.getTime() - 3600 * 1000 * 24)
              } else {
                date.setMonth(date.getMonth() + 1, 1)
                date.setTime(date.getTime() - 3600 * 1000 * 24)
              }
              picker.$emit('pick', date)
            }
          }
        ]
      }
    }
  },
  computed: {

    id() {
      return this.$route.params.id || ''
    },

    normalProjectList() {
      return this.$store.state.projectList
    }
  },
  filters: {
    imgListFormat(list) {
      const imgTypeList = ['jpeg', 'jpg', 'png']
      const imgList = []
      list.forEach((item) => {
        const str = item.fileName.split('.')
        if (imgTypeList.find((items) => items === str[str.length - 1].toLowerCase())) {
          imgList.push(item.filePrefix + item.fileUrl)
        }
      })
      return imgList || []
    }
  },

  // 如果需要做工作台新增跳转到这个页面且带上项目id，加上这段代码
  // get projectId () {
  //   console.log('projectId', this.$route.query.projectId)
  //   return this.$route.query.projectId as string || ''
  // }

  created() {
    this.id && this.getDetail()
    // if (this.projectId) {
    //   this.info.projectId = this.projectId
    //   this.getTypeList()
    // }
  },
  methods: {
    getTypeList() {
      this.info.orderType = ''
      this.info.orderUserId = ''
      this.info.projectAreaId = ''
      this.getAreaList()
      this.$axios.get(this.$apis.workOrder.selectWorkOrderTypeByList, {
        projectId: this.info.projectId,
        orderTypeStatus: '1'
      }).then((res) => {
        this.typeList = res.list || []
      })
    },

    getRoleList() {
      this.info.orderUserId = ''
      this.$axios.get(this.$apis.workOrder.selectOrderTypeFeedbackUserByList, {
        orderType: this.info.orderType,
        projectId: this.info.projectId
      }).then((res) => {
        this.roleList = res || []
      })
    },

    // 获取区域
    getAreaList() {
      this.$axios.get(this.$apis.project.selectYhProjectAreaByList, {
        projectId: this.info.projectId
      }).then(res => {
        this.areaList = res || []
      })
    },

    getDetail() {
      this.$axios.get(this.$apis.carManage.selectYhVehicleByVehicleId, { vehicleId: this.id }).then(res => {
        if (res) {
          this.info = res
          this.dateArr = [res.insuranceStartTime, res.insuranceEndTime]
        }
      })
    },

    imgRemove(index) {
      this.info.fileList.splice(index, 1)
    },

    // 文件上传成功返回
    onSuccess(file) {
      this.info.fileList.push(file)
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },

    getAddressInfo() {
      if (this.info.address && this.info.latitude && this.info.longitude) {
        this.addressInfo.address = this.info.address
        this.addressInfo.latitude = this.info.latitude
        this.addressInfo.longitude = this.info.longitude
      }
      this.addressShow = true
      this.$axios.get(this.$apis.project.selectYhProjectMapByProjectId, {
        projectId: this.info.projectId
      }).then((res) => {
        const lng = this.info.longitude ? Number(this.info.longitude) : Number(res.longitude)
        const lat = this.info.latitude ? Number(this.info.latitude) : Number(res.latitude)
        this.$nextTick(() => {
          this.initMap(lng, lat)
        })
      })
    },

    // 初始化地图
    initMap(lng, lat) {
      if (this.map) {
        this.map.setCenter([lng, lat])
      } else {

        AMap.plugin(['AMap.MouseTool'], () => {
          this.map = new AMap.Map('map', {
            center: [lng, lat],
            zoom: 15
          })
          this.map.on('click', this.mapClick)
        })
      }
    },

    mapClick(e) {
      let geocoder = null
      this.map.plugin(['AMap.Geocoder'], () => {
        geocoder = new AMap.Geocoder({
          city: '全国'
        })
        const lnglat = [e.lnglat.lng, e.lnglat.lat]
        geocoder.getAddress(lnglat, (status, result) => {
          if (status === 'complete' && result.info === 'OK') {
            const site = result.regeocode.formattedAddress || ''
            this.addMarker(e.lnglat.lng, e.lnglat.lat)
            this.addressInfo.address = site
            this.addressInfo.latitude = e.lnglat.lat.toString()
            this.addressInfo.longitude = e.lnglat.lng.toString()
          }
        })
      })
    },

    addMarker(lng, lat) {
      this.map.remove(this.marker)
      if (lng && lat) {
        this.marker = []
        const marker = new AMap.Marker({
          map: this.map,
          position: new AMap.LngLat(lng, lat),
          offset: new AMap.Pixel(-20, -10),
          icon: LocationImg
        })
        this.marker.push(marker)
        this.map.add(marker)
        this.map.setCenter([lng, lat])
      }
    },

    // 详细地址输入
    addrFetch(queryString, cb) {
      AMap.plugin(['AMap.AutoComplete'], () => {
        // 实例化Autocomplete
        const autoComplete = new AMap.AutoComplete({
          city: this.addressInfo.area
        })
        autoComplete.search(this.addressInfo.area + queryString, (status, result) => {
          if (status === 'complete') {
            cb(result.tips)
          }
        })
      })
    },

    // 点击详细地址下拉
    addrChange(data) {
      if (data.location) {
        this.addressInfo.address = data.name
        this.addressInfo.latitude = data.location.getLat().toString()
        this.addressInfo.longitude = data.location.getLng().toString()
        this.map.setCenter([Number(this.addressInfo.longitude), Number(this.addressInfo.latitude)])
      }
    },

    submitAddress() {
      this.info.address = this.addressInfo.address
      this.info.latitude = this.addressInfo.latitude
      this.info.longitude = this.addressInfo.longitude
      this.handleClose()
    },

    handleClose() {
      this.addressShow = false
      this.addressInfo = {
        address: '',
        latitude: '',
        longitude: '',
        area: ''
      }
    },

    saveForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$axios.post(this.$apis.workOrder.insertWorkOrder, {
            ...this.info
          }).then(() => {
            this.$message.success('保存成功')
            this.$router.back()
            // this.$router.push({
            //   name: 'myOrder'
            // })
          })
        }
      })
    }
  }

}
</script>

<style scoped lang="scss">
@import "@/assets/scss/color";

.imgList {
  display: flex;
  flex-wrap: wrap;

  .imgBlock {
    position: relative;
    height: 104px;
    width: 104px;
    margin: 0 10px 10px 0;

    .el-image,
    img,
    video {
      width: 100%;
      height: 100%;
    }

    span {
      position: absolute;
      top: 0;
      right: 0;
      width: 0px;
      height: 0px;
      border-top: 34px solid $color-default;
      border-left: 34px solid transparent;
    }

    i {
      transition: all 0.3s;
      position: absolute;
      top: 3px;
      right: 3px;
      font-size: 15px;
      color: #ffffff;
      cursor: pointer;
    }

    i:hover {
      color: #ffffff98;
    }
  }

  ::v-deep .el-upload--picture-card {
    width: 104px;
    height: 104px;
    line-height: 26px;
    padding: 25px 10px;
  }
}

.address {
  margin-left: 16px;
}

#map {
  width: 100%;
  height: 450px;
  border-radius: 0 0 10px 10px;
}

::v-deep .el-dialog__header {
  border-bottom: none;
  padding: 22px 20px;
  display: flex;
  align-items: center;

  .el-dialog__title {
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    text-shadow: 0px 6px 14px rgba(205, 205, 205, 0.5);
  }

  .el-dialog__close {
    &::before {
      font-size: 16px;
    }
  }
}

::v-deep .el-dialog__body {
  padding: 2px;
  position: relative;

  .el-input--small .el-input__inner {
    height: 36px;
    line-height: 36px;
  }

  .el-input__prefix {
    padding-top: 3px;
  }
}

.search {
  position: absolute;
  top: 20px;
  left: calc(50% - 250px);
}

.submitBtn {
  width: 80px;
  height: 32px;
  background: var(--color-primary);
  box-shadow: 0px 6px 14px 0px rgba(205, 205, 205, 0.5);
  position: absolute;
  bottom: 18px;
  left: calc(50% - 40px);
  border-radius: 15px;
}
</style>
